export const GIGABYTE = 1000 * 1000 * 1000;

export default {
  GIGABYTE,
};
